import { TableCell, TableRow, Typography } from '@mui/material';
import * as React from 'react';
import { dayjs } from '../../../../../date-util';
import { LogEvent } from '../../api/scriptLogs';
import { SCRIPT_LOGS_PLUGIN_ROW_DATE_FORMAT } from '../../data/constants';

const ScriptLogRowNested = (props: LogEvent) => {
	const { message, timestamp } = props;
	return (
		<TableRow>
			<TableCell sx={{ minWidth: 160 }}>
				<Typography fontWeight={500} variant='body2'>
					{dayjs(parseInt(timestamp)).format(
						SCRIPT_LOGS_PLUGIN_ROW_DATE_FORMAT(),
					)}
				</Typography>
			</TableCell>
			<TableCell>{message}</TableCell>
		</TableRow>
	);
};

export default ScriptLogRowNested;
